export default __webpack_public_path__ + "static/media/element_68.802fce24.jpg";